// LEGACY UI: replace with Button from @workspace/frontend-ui.
// Don't import this in new code; legacy-ui.json tracks the remaining importers
// and only shrinks (scripts/legacy-ui-check.mjs).
import classNames from "@casino/external/classNames";
import ButtonContent from "./ButtonContent";
import ButtonComponent from "./styles/ButtonComponent";
import Hover from "./styles/Hover";
import type Props from "./types/Props";
import type Variants from "./types/Variants";

const Button: FC<Props> = ({
  children,
  variant = "fill",
  size = "md",
  iconLeft,
  iconRight,
  fullWidth,
  disabled,
  animation,
  as,
  className,
  ...rest
}) => {
  const customClassName = classNames(
    "text-white bg-primary",
    variant === "secondary" &&
      "text-foreground bg-transparent ring-inset ring-1 ring-secondary hover:ring-foreground",
    variant === "tertiary" && "text-white bg-muted",
    variant === "ghost" && "text-white bg-transparent hover:ring-0 ring-0",
    className,
  );

  return (
    <ButtonComponent
      size={size}
      variant={variant as Variants}
      iconLeft={iconLeft}
      iconRight={iconRight}
      fullWidth={fullWidth}
      disabled={disabled}
      animation={animation}
      as={as}
      customClassName={customClassName}
      {...rest}
    >
      <ButtonContent
        variant={variant}
        size={size}
        iconLeft={iconLeft}
        iconRight={iconRight}
        fullWidth={fullWidth}
        animation={animation}
      >
        {children}
      </ButtonContent>
      <Hover />
    </ButtonComponent>
  );
};

export default Button;
